export const controlHeight = 'clamp(34px, 3.2vw, 54px)'
export const controlFontSize = 'clamp(14px, 1vw, 16px)'

/**
 * `filled` paints the field like the text fields of a filter toolbar. Anywhere
 * else the text fields have no fill, so the date field has none either.
 */
export const filterToolbarDateSx = (
  isDarkMode: boolean,
  active = true,
  filled = false
) => {
  const border = active
    ? isDarkMode
      ? '#BBD7FF'
      : '#003F61'
    : isDarkMode
      ? '#4B6FB1'
      : '#C0C2D6'
  const text = isDarkMode ? '#BBD7FF' : '#003F61'

  return {
    '--filter-outline': border,
    direction: 'rtl',
    '& .MuiPickersOutlinedInput-root': {
      ...(filled && { backgroundColor: isDarkMode ? '#0D192E' : '#FFF' }),
      color: text,
      fontFamily: 'Rubik, sans-serif',
      fontSize: controlFontSize,
      height: controlHeight,
      minHeight: controlHeight,
      width: '100%',
      padding: '0 10px',
      direction: 'rtl',
      display: 'flex',
      alignItems: 'center',
      borderRadius: '4px',
    },
    '& .MuiPickersOutlinedInput-notchedOutline': {
      borderColor: 'var(--filter-outline) !important',
      borderWidth: '1px !important',
      direction: 'rtl',
      textAlign: 'right',
    },
    '& .MuiPickersOutlinedInput-notchedOutline legend': {
      width: 'fit-content !important',
      maxWidth: 'fit-content !important',
      marginLeft: 'auto',
      marginRight: '6px',
    },
    '& .MuiPickersInputBase-sectionsContainer': {
      flex: 1,
      minWidth: 0,
      padding: '0 !important',
      direction: 'ltr',
      justifyContent: 'flex-end !important',
      textAlign: 'right',
      fontFamily: 'Rubik, sans-serif',
      fontSize: controlFontSize,
      color: text,
    },
    '& .MuiInputAdornment-root, & .MuiIconButton-root': {
      margin: 0,
      padding: 0,
    },
    '& .MuiIconButton-root img': {
      filter: isDarkMode
        ? 'brightness(0) saturate(100%) invert(84%) sepia(18%) saturate(1143%) hue-rotate(185deg) brightness(103%) contrast(103%)'
        : 'brightness(0) saturate(100%) invert(20%) sepia(35%) saturate(1665%) hue-rotate(157deg) brightness(91%) contrast(102%)',
    },
    '& .MuiInputLabel-root': {
      right: '14px',
      left: 'auto',
      transformOrigin: 'top right',
      transform: 'translate(0, -7px) scale(0.75)',
      color: `${text} !important`,
      backgroundColor: 'transparent',
      padding: 0,
      zIndex: 2,
    },
  }
}

/** Colors for the calendar surface opened by the date fields. */
export const filterToolbarDatePickerPopupSx = (isDarkMode: boolean) => {
  const surface = isDarkMode ? '#202B40' : '#FFFFFF'
  const text = isDarkMode ? '#BBD7FF' : '#003F61'
  const muted = isDarkMode ? '#8EA3C2' : '#718096'
  const hover = isDarkMode ? '#2D4773' : '#E8F2FC'
  const selected = isDarkMode ? '#2F6FC2' : '#6EA2E8'

  return {
    '& .MuiPaper-root, & .MuiDateCalendar-root': {
      backgroundColor: surface,
      color: text,
    },
    '& .MuiCalendarOrClockPicker-root': { backgroundColor: surface },
    '& .MuiPickersCalendarHeader-root, & .MuiPickersCalendarHeader-label': {
      color: text,
    },
    '& .MuiPickersArrowSwitcher-button': {
      color: text,
      '&:hover': { backgroundColor: hover },
    },
    '& .MuiDayCalendar-weekDayLabel': { color: muted },
    '& .MuiPickersDay-root': {
      color: text,
      '&:hover': { backgroundColor: hover },
      '&.Mui-selected': {
        backgroundColor: selected,
        color: '#FFFFFF',
        '&:hover': { backgroundColor: selected },
      },
      '&.Mui-disabled': { color: muted },
    },
    '& .MuiPickersYear-yearButton, & .MuiPickersMonth-monthButton': {
      color: text,
      '&:hover': { backgroundColor: hover },
      '&.Mui-selected': { backgroundColor: selected, color: '#FFFFFF' },
      '&.Mui-disabled': { color: muted },
    },
  }
}
